module.exports = __webpack_public_path__ + "img/static__image.9ef04539.png";